// extracted by mini-css-extract-plugin
export default {"restaurantList":"index_restaurantList_Rj-l4 clearfix"};